export default __webpack_public_path__ + "static/media/maintenance.60766547.svg";